import { authedFetch, getJSON } from './http';
import type { Question } from './vouchers';

type Auth = { getToken: () => string | null; hydrate: () => Promise<void> };

// ── Tournament + settings (public) ──────────────────────────────────────────
export type TournamentInfo = {
  code: string;
  status: string;
  prizeLitres: number | null;
  committedLitres: number;
  pendingLitres: number;
  prizeCounterVisible: boolean;
  partnersRevealed: boolean;
};

export function getTournament(code = 'wc2026'): Promise<TournamentInfo> {
  return getJSON(`/api/tournaments/${code}`);
}

export type AppSettings = {
  comments: { enabled: boolean; disabledMessage?: string };
  testTournamentCode?: string;
};

export function getSettings(): Promise<AppSettings> {
  return getJSON('/api/settings');
}

// ── Partners (public) ───────────────────────────────────────────────────────
export type PartnerHour = { weekday: number; opensAt: string; closesAt: string };
export type Partner = {
  id: number;
  slug: string;
  name: string;
  logoPath?: string;
  whiteBg?: boolean;
  url?: string;
  tier: string;
  canton?: string;
  address?: string;
  lat?: number;
  lng?: number;
  servesThird: boolean;
  servesHalf: boolean;
  servesPint: boolean;
  active: boolean;
  openNow?: boolean;
  hours: PartnerHour[];
};

export async function listPartners(): Promise<Partner[]> {
  const body = await getJSON<{ partners: Partner[] }>('/api/partners');
  return body.partners ?? [];
}

export type Article = {
  id: number;
  partnerId?: number;
  partnerName?: string;
  kind: string;
  title: string;
  description?: string;
  imagePath?: string;
  valueChf?: number;
  stock?: number;
  delivery: string;
  active: boolean;
  questions?: Question[];
};

export async function listPartnerArticles(partnerId: number): Promise<Article[]> {
  const body = await getJSON<{ articles: Article[] }>(`/api/partners/${partnerId}/articles`);
  return body.articles ?? [];
}

export async function listArticles(canton?: string): Promise<Article[]> {
  const q = canton ? `?canton=${encodeURIComponent(canton)}` : '';
  const body = await getJSON<{ articles: Article[] }>(`/api/articles${q}`);
  return body.articles ?? [];
}

// ── Me/rank (auth) ──────────────────────────────────────────────────────────
export type MeRank = { rank: number | null; pts: number | null; picks: number | null; total: number };
export function getMyRank(auth: Auth): Promise<MeRank> {
  return authedFetch(auth.getToken, auth.hydrate, '/api/me/rank');
}
